import { render, staticRenderFns } from "./documentos-adjuntos-propietarios.vue?vue&type=template&id=67380a3a&"
import script from "./documentos-adjuntos-propietarios.vue?vue&type=script&lang=js&"
export * from "./documentos-adjuntos-propietarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports